import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { clickEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import * as pushUpActions from 'state/bump/actions';
import { actions as itemActions } from 'state/items/slice';
import { actions as profileActions } from 'state/profile/slice';
import { getVasGalleryAbTest } from 'state/vas-gallery/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { jsx as _jsx } from "react/jsx-runtime";

const ProfileItemPushUpButton = _ref => {
  let {
    item
  } = _ref;
  const dispatch = useDispatch();
  const {
    track
  } = useTracking();
  const translate = useTranslate('item.actions');
  const vasGalleryAbTest = useSelector(getVasGalleryAbTest);
  const isVasGalleryFeatureDisabled = useSelector(getIsFeatureSwitchEnabled('disable_vas_gallery_orders'));
  const isVasGalleryEnabled = vasGalleryAbTest.visible && !isVasGalleryFeatureDisabled;

  function handleOnClickPromote() {
    dispatch(profileActions.setPromotedItemId({
      id: item.id
    }));
    track(clickEvent({
      target: ClickableElement.PromoteItem,
      targetDetails: "".concat(item.id)
    }));
  }

  function handleOnClick() {
    dispatch(itemActions.setUserItems({
      items: [item]
    }));
    dispatch(pushUpActions.startCheckout({
      selectedItemId: item.id
    }));
    track(clickEvent({
      target: ClickableElement.PushUpItem,
      targetDetails: "".concat(item.id)
    }));
  }

  return /*#__PURE__*/_jsx(Button, {
    disabled: !item.can_push_up && !item.can_vas_gallery_promote,
    size: Button.Size.Small,
    text: translate(isVasGalleryEnabled ? 'promote' : 'bump'),
    onClick: isVasGalleryEnabled ? handleOnClickPromote : handleOnClick,
    testId: "bump-button"
  });
};

export default ProfileItemPushUpButton;